import { useMemo, useState } from 'react';

import { TableExt, TopRow, Confirm, Total, TotalBox, GridBox, GridUpdateMessage, themes } from 'libs/ui';
import { getTableParams } from './grid.params';
import { useTranslation } from 'react-i18next';
import { path } from 'router/sections';
import { getRefundRollback } from 'services/reports-service';

export const RollbackGrid = (props) => {
  const { count, entries, className, theme, getXlsAction, history } = props;

  const [showForm, setShowForm] = useState('');
  const [message, setMessage] = useState('');
  const [row, setRow] = useState({});
  const [confirm, setConfirm] = useState(null);

  const { t } = useTranslation();

  // items
  const items = Object.keys(entries).map((key) => entries[key]);

  const messageText = t('messages.Изменение сохранено');
  const errorTextPayed = t('messages.Уже оплачено');

  // top actions
  const topActions = [];
  if (count) {
    getXlsAction(topActions);
  }

  // actions
  const refundRollbackAction = (row) => {
    setRow(row);
    setShowForm('showConfirm');
  };

  const handleRefundRollback = (row) => {
    getRefundRollback(row.id)
      .then(() => {
        setMessage(messageText);
        setShowForm('');
        props.refresh();
        setTimeout(() => {
          setMessage('');
        }, 3000);
      })
      .catch((error) => {
        if (error.endsWith('already paid')) {
          setMessage(errorTextPayed);
          setShowForm('');
          props.refresh();
          setTimeout(() => {
            setMessage('');
          }, 3000);
        }
      });
  };

  const reportsAction = (row) => {
    setRow(row);
    history.push(`${path('stay')}?id=${row.stay_id}`);
  };

  const actions = [];

  actions.push({
    title: t('buttons.Перейти в карточку парковки'),
    action: reportsAction,
  });

  actions.push({
    title: t('messages.Вернуть сдачу'),
    action: (row) => refundRollbackAction(row),
    isVisible: (row) => !row.success,
  });

  /**
   * close confirm
   */
  const closeConfirm = () => {
    setConfirm(null);
    setShowForm('');
  };

  const tableParams = useMemo(() => getTableParams(t), [t]);

  return (
    <GridBox>
      <TopRow>
        <TotalBox>
          <Total cnt={count} />
        </TotalBox>
      </TopRow>

      <TableExt
        theme={theme}
        title={t('sections.Сдача')}
        rows={{ count, items }}
        topActions={topActions}
        actions={actions}
        className={className}
        clientId={props.clientId}
        // onRowClick={rightEdit ? editItemAction : undefined}
        {...tableParams}
      />
      {showForm && showForm === 'showConfirm' && (
        <Confirm
          title={t('messages.Вернуть сдачу') + ` ${Math.abs(row.amount).toFixed(2) / 100} ` + t('grid.₽') + '?'}
          acceptButton={{
            theme: themes.blue,
            text: t('buttons.Вернуть'),
            func: () => handleRefundRollback(row),
          }}
          cancelButton={{
            func: closeConfirm,
            text: t('buttons.Отменить'),
          }}
        />
      )}

      {message && <GridUpdateMessage>{message}</GridUpdateMessage>}
    </GridBox>
  );
};
